import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { habitosService } from '../services/habitos.service';
import { useAuthStore } from '../store/useAuthStore';
import { useWorkspaceStore } from '../store/useWorkspaceStore';

export const useHabitosQuery = () => {
  const { token } = useAuthStore();
  const { activeWorkspaceId } = useWorkspaceStore();
  
  return useQuery({
    queryKey: ['habitos', activeWorkspaceId],
    queryFn: habitosService.getHabitos,
    enabled: !!token && activeWorkspaceId !== 'default',
    initialData: [],
  });
};

export const useCrearHabitoMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: habitosService.crearHabito,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['habitos'] });
    },
  });
};

export const useActualizarHabitoMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: habitosService.actualizarHabito,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['habitos'] });
    },
  });
};

export const useEliminarHabitoMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: habitosService.eliminarHabito,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['habitos'] });
    },
  });
};
